import './Dessins.scss';

import logo from '../../Navbar/Logo_skinny.png';
import Loader from '../../Loader/Loader';

import {NavLink, useNavigate} from 'react-router-dom';

import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import CottageIcon from '@mui/icons-material/Cottage';

const Dessins = ({datas, loader}) => {

const navigate = useNavigate();
  
  return loader ? (
    <Loader />
  )
  :
  (
    <div className='page'>
     
      <h1 className='page-title'>

    <NavLink
        to='/'
      > <img src={logo}  alt='logo skinny' className='logo_pages-banner'/>
     
    </NavLink>
      
       - Catégorie Dessins - </h1>
       <div className="img_container">
      {datas.map((data, index) => {
        return(

        <NavLink
        to={`/draw/zoom/${data.id}`} >

         <img src={data.url} alt='dessins' className='data_item' key={index}/>

        </NavLink>
        )
      })}
       </div>

    <NavLink
    to='/'
    className='page-back'
     > <CottageIcon/>
     
    </NavLink>

    <button
      onClick={() => navigate(-1)}
      className='page-back--btn'
      >  <ArrowBackIosNewIcon/> 
    </button>


     
  
    </div>

  )
  
}

export default Dessins;